import { gql } from '@src/lib/gql'

/**
 * One-time, five-minute token for GET /auth/as-user?token=…. Only an admin session can mint it; whoever
 * opens the link first (e.g. an incognito window) is logged in, so treat it as a short-lived credential.
 * Logging in as an admin or Beancounter/finance account needs isScoAdmin.
 */
export const ADMIN_CREATE_LOGIN_AS_USER_TOKEN = gql`
  mutation AdminCreateLoginAsUserToken($input: AdminCreateLoginAsUserTokenInput!) {
    adminCreateLoginAsUserToken(input: $input) {
      token
      expiresAt
    }
  }
`
